import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { Client } from '../../../client-data/client.model';
import { Document } from '../../../document-data/document.model';
import { Billing } from '../../../document-data/sub-models/billing.model';

@Injectable()
export class DocumentSendBuilder {
  constructor() {}

  buildDocumentWithNewEmails(document: Document, newEmails: List<string>) {
    return document.mergeFieldInContent(
      [Document.CONTENT_KEYS.BILLING],
      document.billing.set(Billing.KEYS.EMAIL, newEmails.join(','))
    );
  }

  buildClientWithNewEmails(client: Client, newEmails: List<string>) {
    return client.setFieldInContent(
      [Client.CONTENT_KEYS.EMAIL],
      newEmails.join(',')
    );
  }
}
